"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ListFilter = _interopRequireDefault(require("@/components/ListFilter"));
var _fliterConfig = _interopRequireDefault(require("./fliterConfig.js"));
var _paginationEffect = _interopRequireDefault(require("@/utils/paginationEffect"));
var _ReceiveRecordDetail = _interopRequireDefault(require("./modules/ReceiveRecordDetail.vue"));
var _api = require("../api");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CouponRecord',
  components: {
    ListFilter: _ListFilter.default,
    ReceiveRecordDetail: _ReceiveRecordDetail.default
  },
  data: function data() {
    return _objectSpread(_objectSpread({
      listLoading: false,
      exportLoading: false,
      importLoading: false,
      tableData: {
        list: [],
        total: 0
      },
      tableFrom: {}
    }, (0, _fliterConfig.default)({
      handleSearch: this.handleSearch
    })), (0, _paginationEffect.default)(this.handlerGetListData));
  },
  created: function created() {
    this.handlerGetListData(this.pageData);
  },
  mounted: function mounted() {
    // 在mounted后加载地区数据，确保Vue响应式系统已初始化
    this.loadAreaOptions();
  },
  methods: {
    handleSearch: function handleSearch(data) {
      if (data) {
        this.tableFrom = _objectSpread({}, data);
      } else {
        this.tableFrom = {};
      }
      this.resetPageData();
    },
    handlerGetListData: function () {
      var _handlerGetListData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.listLoading = true;
              params = _objectSpread(_objectSpread({}, this.tableFrom), this.pageData);
              _context.p = 1;
              _context.n = 2;
              return (0, _api.receiveRecordApi)(params);
            case 2:
              data = _context.v;
              this.tableData = data || {
                list: [],
                total: 0
              };
              this.listLoading = false;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.listLoading = false;
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handlerGetListData() {
        return _handlerGetListData.apply(this, arguments);
      }
      return handlerGetListData;
    }(),
    viewDetail: function viewDetail(row) {
      this.$refs.recordDetailRef.open(row);
    },
    loadAreaOptions: function () {
      var _loadAreaOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, areaItem, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (this.loadAreaData) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return this.loadAreaData();
            case 2:
              res = _context2.v;
              // 使用$set确保响应式更新
              areaItem = this.FILTER_ITEMS.find(function (item) {
                return item.prop === 'areaScope';
              });
              if (areaItem && areaItem.attrs && res && Array.isArray(res)) {
                this.$set(areaItem.attrs, 'options', res);
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.error('加载地区数据失败:', _t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function loadAreaOptions() {
        return _loadAreaOptions.apply(this, arguments);
      }
      return loadAreaOptions;
    }(),
    handleExport: function () {
      var _handleExport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var exportParams, res, downloadUrl, link, fileName, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.exportLoading = true;
              _context3.p = 1;
              // 使用当前筛选条件作为导出参数
              exportParams = _objectSpread({}, this.tableFrom); // 移除分页参数
              delete exportParams.page;
              delete exportParams.limit;
              _context3.n = 2;
              return (0, _api.exportReceiveRecordApi)(exportParams);
            case 2:
              res = _context3.v;
              if (res && res.fileName) {
                try {
                  // 获取文件下载URL
                  downloadUrl = res.fileName; // 创建下载链接并点击
                  link = document.createElement('a');
                  link.style.display = 'none';
                  link.href = downloadUrl;

                  // 从URL中提取文件名
                  fileName = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1); // 直接打开链接，不使用download属性，避免跨域问题
                  link.setAttribute('target', '_blank');
                  document.body.appendChild(link);
                  link.click();
                  setTimeout(function () {
                    document.body.removeChild(link);
                  }, 100);
                  this.$message.success('导出成功，请在新窗口中下载文件');
                } catch (err) {
                  this.$message.error('下载文件失败: ' + err.message);
                }
              } else {
                this.$message.error(res && res.message ? res.message : '导出失败');
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              this.$message.error('导出失败: ' + (_t3.message || '未知错误'));
            case 4:
              _context3.p = 4;
              this.exportLoading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    handleImport: function handleImport() {
      var _this = this;
      // 创建文件输入元素
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = '.xlsx,.xls';
      input.style.display = 'none';
      input.onchange = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(event) {
          var file, fileName, fileExtension;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                file = event.target.files[0];
                if (file) {
                  _context5.n = 1;
                  break;
                }
                return _context5.a(2);
              case 1:
                // 验证文件类型
                fileName = file.name;
                fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
                if (!(fileExtension !== 'xlsx' && fileExtension !== 'xls')) {
                  _context5.n = 2;
                  break;
                }
                _this.$message.error('请选择Excel文件（.xlsx或.xls格式）');
                return _context5.a(2);
              case 2:
                // 确认导入
                _this.$confirm('确定要导入Excel数据吗？导入将根据优惠券名称创建伪造的使用记录。', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                  var res, _t4;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.p = _context4.n) {
                      case 0:
                        _this.importLoading = true;
                        _context4.p = 1;
                        _context4.n = 2;
                        return (0, _api.importFakeCouponRecordApi)(file);
                      case 2:
                        res = _context4.v;
                        if (res) {
                          _this.$message.success(res || '导入成功');
                          // 刷新列表
                          _this.handlerGetListData();
                        } else {
                          _this.$message.error('导入失败');
                        }
                        _context4.n = 4;
                        break;
                      case 3:
                        _context4.p = 3;
                        _t4 = _context4.v;
                        _this.$message.error('导入失败: ' + (_t4.message || '未知错误'));
                      case 4:
                        _context4.p = 4;
                        _this.importLoading = false;
                        // 清理input元素
                        document.body.removeChild(input);
                        return _context4.f(4);
                      case 5:
                        return _context4.a(2);
                    }
                  }, _callee4, null, [[1, 3, 4, 5]]);
                }))).catch(function () {
                  // 用户取消，清理input元素
                  document.body.removeChild(input);
                });
              case 3:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();

      // 添加到DOM并触发点击
      document.body.appendChild(input);
      input.click();
    }
  }
};